<script setup lang="ts">
import PulseEffect from "@/modules/explorer/components/PulseEffect.vue";
import { useDashboardStore } from "@/modules/dashboards/store";
const live = defineModel<boolean>();
const updating = defineModel<boolean>("updating", {
	default: false,
});

const dashboardState = useDashboardStore().dashboardState;
</script>

<template>
	<v-btn
		:disabled="dashboardState.editorMode !== 'view'"
		variant="flat"
		class="px-0"
		:color="live ? 'secondary' : 'transparent'"
		style="min-width: 26px"
		height="26"
		@click="live = !live"
	>
		<div v-if="live" class="d-flex align-center px-1">
			<v-progress-circular
				style="opacity: 0.7"
				indeterminate
				color="error"
				size="20"
				width="2"
				v-if="updating"
			/>
			<pulse-effect v-else />
			<div class="live-text px-2">LIVE</div>
		</div>
		<div v-else class="d-flex align-center justify-center">
			<i class="fa-duotone fa-circle-play fa-xl"></i>
		</div>
	</v-btn>
</template>

<style scoped lang="css">
.live-text {
	font-weight: 600;
	font-size: 14px;
}
</style>
